import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { Countdown } from '../Countdown';
import { CTAButton } from '../CTAButton';
import { plans } from '../../data/programa';
const summaries: Record<string, string> = {
  standard: '6 Tomos + 6 Bonos',
  elite: '6 Tomos + 6 Bonos + Intervención Crítica'
};
export function Pricing() {
  const [selectedId, setSelectedId] = useState('elite');
  const selected = plans.find(plan => plan.id === selectedId) ?? plans[1];
  return <section id="precio" className="relative overflow-hidden border-b border-line bg-carbon py-[60px] lg:py-[100px]" data-id="element-194" data-mp="3uiktwv5rwn71">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-80 bg-[radial-gradient(50%_100%_at_50%_0%,rgba(255,159,28,0.12)_0%,rgba(17,24,39,0)_100%)]" aria-hidden="true" data-id="element-195" data-mp="3ct5c07n9imc" />
      <div className="relative mx-auto max-w-content px-6 text-center lg:px-10" data-id="element-196" data-mp="253mrj6c50y3b">
        <SectionHeading eyebrow="Precio de lanzamiento" title={<>
              Elegí tu pack.{' '}
              <span className="text-gold" data-id="element-198" data-mp="1bcl17eeuc1dt">El precio cierra en:</span>
            </>} data-id="element-197" data-mp="255qthiqh7n0y" />

        <div className="mt-10" data-id="element-199" data-mp="16ip2g9qr6ahl">
          <Countdown label="Cierra el precio de lanzamiento" note="Después sube $10.000 ARS. No vuelve." data-id="element-200" data-mp="11knmhxomirac" />
        </div>

        <fieldset className="mx-auto mt-12 max-w-4xl text-left" data-id="element-201" data-mp="xk4tw1ewph73">
          <legend className="sr-only" data-id="element-202" data-mp="1u9m6l0cb43ia">Elegí tu pack</legend>
          <div className="grid gap-5 md:grid-cols-2" data-id="element-203" data-mp="1u92onjmnpf49">
            {plans.map((plan, index) => {
            const isSelected = plan.id === selectedId;
            return <Reveal key={plan.id} delay={index * 0.06} className="h-full" data-id="element-204" data-mp="1l8ekrhqz8v53" data-mpi={index}>
                  <label className={`relative flex h-full cursor-pointer flex-col rounded-2xl border bg-white/[0.04] p-7 backdrop-blur-[10px] transition-[border-color,box-shadow] duration-200 ease-smooth ${isSelected ? 'border-gold shadow-glow' : 'border-gold/20 hover:border-gold/50'}`} data-id="element-205" data-mp="1g9tlbkjjufhp">
                    <input type="radio" name="pack" value={plan.id} checked={isSelected} onChange={() => setSelectedId(plan.id)} className="sr-only" data-id="element-206" data-mp="4x0tk9qrdr1n" />

                    {plan.featured ? <span className="absolute -top-3 left-7 rounded-full bg-gold px-4 py-1 text-[11px] font-bold uppercase tracking-[0.1em] text-ink" data-id="element-207" data-mp="baejur1lawm7">
                        Recomendado
                      </span> : null}

                    <div className="flex items-start justify-between gap-4" data-id="element-208" data-mp="1el99d7fld72">
                      <h3 className="text-[22px] font-bold leading-tight tracking-tight text-ice" data-id="element-209" data-mp="3jp56qq77rrjn">
                        {plan.name}
                      </h3>
                      <span className={`mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ${isSelected ? 'border-gold bg-gold text-ink' : 'border-cool/60 text-transparent'}`} aria-hidden="true" data-id="element-210" data-mp="39tboqraq75uh">
                        <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-211" data-mp="30t6qp7rf9jsz" />
                      </span>
                    </div>

                    <p className="mt-3 text-[13px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-212" data-mp="35t1iddj0udf3">
                      {summaries[plan.id]}
                    </p>

                    <p className="mt-4 flex-1 text-[15px] leading-[1.6] text-cool" style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  width: "290px",
                  height: "50px"
                }} data-id="element-213" data-mp="2h7dlip9gfr10">
                      <span className="text-ice" data-id="element-214" data-mp="35415op2edhge">Ideal para:</span>{' '}
                      {plan.idealFor}
                    </p>

                    <div className="mt-7 flex flex-wrap items-end gap-3 border-t border-line pt-6" data-id="element-215" data-mp="303wp6z1homq6">
                      <span className="text-[38px] font-bold leading-none tracking-tight text-ice" data-id="element-216" data-mp="3essvaqjzjpo5">
                        {plan.price}
                      </span>
                      <span className="text-[12px] font-medium uppercase tracking-[0.1em] text-cool" data-id="element-217" data-mp="3nu95oyasvrsd">
                        ARS
                      </span>
                      <span className="ml-auto text-[16px] text-cool line-through" data-id="element-218" data-mp="3ix8ygk27sizo">
                        {plan.originalPrice}
                      </span>
                    </div>
                  </label>
                </Reveal>;
          })}
          </div>
        </fieldset>

        <Reveal delay={0.1} className="mx-auto mt-10 max-w-md" data-id="element-219" data-mp="1qx4l7p9w88g1">
          <CTAButton pulse data-id="element-220" data-mp="1uxextks6xx3v">{selected.cta}</CTAButton>
        </Reveal>
      </div>
    </section>;
}